import {
  getMakes,
  getModels,
  getVariants,
  getYears,
} from "../api/vehicleController";
import { useEffect, useState } from "react";
import { map, sortBy } from "lodash";

const fetchMakeData = async ({
  userInput,
  setMakeOptions,
  setLoading,
}) => {
  setLoading(true);
  try {
    const response = await getMakes(userInput.year);

    if (!!response?.success) {
        const sortedMakes = map(sortBy(response.data, (x) => x.name), x => {
            return {
                key: x.makeId,
                label: x.name,
                value: x.makeId,
            };
        });
        setMakeOptions(sortedMakes);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

const fetchYearsData = async ({ userInput, setYearOptions, setLoading }) => {
  if (!userInput.make && !userInput.model && !userInput.variant) return;
  setLoading(true);
  try {
    let response = await getYears(
      userInput.make,
      userInput.model,
      userInput.variant,
    );

    if (!!response?.success) {
      const sortedYears = map(sortBy(response.data, (x) => x.name), x => {
          return {
              key: x.yearId,
              label: x.name,
              value: x.yearId,
          };
      });
      setYearOptions(sortedYears);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

const fetchModelsData = async ({ userInput, setModelOptions, setLoading }) => {
  setLoading(true);
  try {
    if (userInput.make || userInput.year) {
      const response = await getModels(
        userInput.make,
        userInput.year,
      );

      if (!!response?.success) {
        const sortedModels = map(sortBy(response.data, (x) => x.name), x => {
            return {
                key: x.modelId,
                label: x.name,
                value: x.modelId,
            };
        });
        setModelOptions(sortedModels);
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

const fetchVariantsData = async ({
  userInput,
  setVariantOptions,
  setLoading,
}) => {
  setLoading(true);
  try {
    if (userInput.make && userInput.model) {
      const response = await getVariants(
        userInput.make,
        userInput.model,
        userInput.year,
      );

      if (!!response?.success) {
        const sortedVariants = map(sortBy(response.data, (x) => x.name), x => {
            return {
                key: x.variantId,
                label: x.name,
                value: x.variantId,
            };
        });
        setVariantOptions(sortedVariants);
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

const useMakeModelYear = () => {
  const [yearOptions, setYearOptions] = useState([]);
  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [userInput, setUserInput] = useState({
    make: null,
    model: null,
    variant: null,
    year: null,
  });

  const clearMakeOptions = () => {
    setMakeOptions([]);
  };

  const clearModelOptions = () => {
    setModelOptions([]);
  };

  const clearVariantOptions = () => {
    setVariantOptions([]);
  };

  const clearYearOptions = () => {
    setYearOptions([]);
  };

  useEffect(() => {
    fetchMakeData({
      userInput,
      setMakeOptions,
      setLoading,
    });
  }, []);

  useEffect(() => {
    fetchModelsData({
      userInput,
      setModelOptions,
      setLoading,
    });
  }, [userInput.make]);

  useEffect(() => {
    fetchVariantsData({
      userInput,
      setVariantOptions,
      setLoading,
    });
  }, [userInput.model]);

  useEffect(() => {
    fetchYearsData({
      userInput,
      setYearOptions,
      setLoading,
    });
  }, [userInput.variant]);

  return {
    yearOptions,
    makeOptions,
    modelOptions,
    variantOptions,
    loading,
    userInput,
    setUserInput,
    clearYearOptions,
    clearVariantOptions,
    clearModelOptions,
    clearMakeOptions,
  };
};

export default useMakeModelYear;
